import React, { useRef } from "react";
// import { Play } from "lucide-react";
import bannerImage from "../../assets/image/header-banner.png";
import groupImage from "../../assets/image/Group.png";
import groupImage2 from "../../assets/image/Group2.png";
import groupImage3 from "../../assets/image/Group3.png";
import plays from "../../assets/image/play.png";

const Banner = ({ formRef }) => {
  const handleClick = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <section className="banner banner-sec-bg">
        <div className="container">
          {/* Left Content  banner-container*/}
          {/* <img src={bannerImage} className="banner-image" alt="Banner Image" /> */}
          <div className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
            <div className="row">
              <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12 col-xs-12">
                <div className="banner-left">
                  <h1 className="banner-title">
                    Create Ayushman Bharat Health Account
                  </h1>
                  <p className="banner-description">
                    ABHA Number Card is a 14-digit unique identification number
                    that serves as an identifier for individuals in India's
                    digital healthcare ecosystem.
                  </p>
                  <div className="button-group">
                    <button
                      className="create-link-btn"
                      id="createabha"
                      onClick={handleClick}
                    >
                      CREATE/LINK ABHA
                    </button>
                    {/* <button className="watch-video-btn">
                      <img src={plays} className="play-icon" />
                      <span>Watch Video</span>
                    </button> */}
                  </div>
                </div>
              </div>

              {/* Right Image */}
              <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12 col-xs-12">
                <div className="banner-right">
                  {/* <img
                  src="/abha-mobile.png"
                  alt="ABHA Phone Illustration"
                  className="image"
                /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Bottom Info Bar */}
      <div className="info-bar banner-second-bg">
        <div className="info-container">
          <div className="col-md-12 col-lg-12">
            <div className="row">
              <div className="col-6 col-md-4">
                <div className="info-item">
                  <img src={groupImage} alt="Link" className="info-icon" />
                  <span>Link Your ABHA with Pathkind Labs</span>
                </div>
              </div>
              <div className="col-6 col-md-4">
                <div className="info-item">
                  <img src={groupImage2} alt="Share" className="info-icon" />
                  <span>
                    Choose with whom you want to share your medical records
                  </span>
                </div>
              </div>
              <div className="col-6 col-md-4">
                <div className="info-item">
                  <img src={groupImage3} alt="Records" className="info-icon" />
                  <span>Link your medical records with ABHA</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
